/* Main app configs go here */


export const appConfig = {
  name: 'Zorkitron',
  shortName: 'Zorkitron',
  description: 'DeFi Passive Income Generator For Liquidity Providers',
  splashScreenBackground: '#ffffff'
}


export const manifestJSON = {
  name: 'Zorkitron',
  short_name: 'Zorkitron',
  description: 'DeFi Passive Income Generator For Liquidity Providers',
  background_color: '#ffffff'
}

export const defaultToastBarHideDuration = 8000

export const socialMediaTags = [
  {
    attributes: {
      property: 'og:title',
      content: 'Zorkitron'
    }
  },
  {
    attributes: {
      property: 'og:description',
      content: 'DeFi Passive Income Generator For Liquidity Providers'
    }
  },
  {
    attributes: {
      property: 'og:image',
      content: 'https://zorkitron.com/assets/zorkitron-social-graph.png'
    }
  },
  {
    attributes: {
      property: 'og:url',
      content: 'https://zorkitron.com'
    }
  },
  {
    attributes: {
      property: 'og:site_name',
      content: 'Zorkitron'
    }
  },
  {
    attributes: {
      property: 'twitter:card',
      content: 'summary_large_image'
    }
  },
  {
    attributes: {
      property: 'twitter:image:alt',
      content: 'Zorkitron, DeFi Passive Income Generator For Liquidity Providers'
    }
  },
  {
    attributes: {
      property: 'twitter:site',
      content: '@Zorkitron'
    }
  },
  {
    attributes: {
      property: 'description',
      content: 'DeFi Passive Income Generator For Liquidity Providers'
    }
  }
]

export const siteMapPaths1 = [
  '/deposit/',
  '/withdraw/',
  '/terms/',
  '/privacy/'
]

// Sitemaps for docs.zorkitron.com are hosted at:
// https://docs.zorkitron.com/traders/sitemap.xml
// https://docs.zorkitron.com/developers/sitemap.xml


//export const LOCALHOST_CONTRACT_ADDRESS = '0x5FbDB2315678afecb367f032d93F642f64180aa3'

export const LOCALHOST_CONTRACT_ADDRESS = '0x28e7C7E48a5c5108a34db251B0e6880456555947'

export const SEPOLIA_CONTRACT_ADDRESS = '0x25f88C973442B575b13241Cc3627C3552851A0e1';
export const MAINNET_CONTRACT_ADDRESS = ''

